import toast from 'react-hot-toast';
import { authenticate } from './helper';

/* User validate */

export async function userValidate(values) {
  const usernameerrors = usernameVerify({}, values);
  const passworderrors = passwordVerify({}, values);

  if (values.username && values.password) {
    // check user exist or not
    const { status } = await authenticate(values.username, values.password);

    if (status !== 200) {
      usernameerrors.exist = toast.error('User does not exist...!');
    }
    if (status !== 200) {
      passworderrors.exist = toast.error('password does not exist...!');
    }
  }

  return { usernameerrors, passworderrors };
}

/** validate login page username */
export async function usernameValidate(values) {
  const errors = usernameVerify({}, values);

  if (values.username) {
    // check user exist or not
    const { status } = await authenticate(values.username);

    if (status !== 200) {
      errors.exist = toast.error('User does not exist...!');
    }
  }

  return errors;
}

/** validate password */
export async function passwordValidate(values) {
  const errors = passwordVerify({}, values);

  return errors;
}

/** validate reset password */
export async function resetPasswordValidation(values) {
  const errors = passwordVerify({}, values);

  if (values.password !== values.confirm_pwd) {
    errors.exist = toast.error('Password not match...!');
  }

  return errors;
}

/** validate register form */
export async function registerValidation(values) {
  // const errors = usernameVerify({}, values);
  let errors ={}
  const mappedValues = { ...values, newPass: values.password };
  passwordVerify(errors, mappedValues);
  emailVerify(errors, values);
  if (values.username !== values.email) {
    errors.username = toast.error('Username should be the same as Email...!');
  }
  employeeIDVerify(errors, values);
  DOBVerify(errors, values);
  PhoneNumberVerify(errors, values);
  specialistIdVerify(errors, values);
  return errors;
}

/** validate profile page */
export async function profileValidation(values) {
  const errors = emailVerify({}, values);
  return errors;
}

/** ************************************************* */

/** validate password */
function passwordVerify(errors = {}, values) {
  const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

  if (!values.newPass) {
    errors.newPass = toast.error('Password Required...!');
  } else if (values.newPass.includes(' ')) {
    errors.newPass = toast.error('Wrong Password...!');
  } else if (values.newPass.length < 4) {
    errors.newPass = toast.error('Password must be more than 4 characters long');
  } else if (!specialChars.test(values.newPass)) {
    errors.newPass = toast.error('Password must have special character');
  }

  return errors;
}

/** validate username */
function usernameVerify(error = {}, values) {
  //FN: Adduser form only taking email in this field-BUG
  if (!values.username) {
    error.username = toast.error('Username Required...!');
  } else if (values.username.includes(' ')) {
    error.username = toast.error('Invalid Username...!');
  }

  return error;
}

/** validate email */
export function emailVerify(error = {}, values, key="email") {
  if (!values[key]) {
    error[key] = toast.error('Email Required...!');
  } else if (values[key].includes(' ')) {
    error[key] = toast.error('Wrong Email...!');
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values[key])) {
    error[key] = toast.error('Invalid email address...!');
  }

  return error;
}

/** validate employeeID */
function employeeIDVerify(error = {}, values) {
  if (!values.employeeid) {
    error.employeeid = toast.error('Employee ID is required');
  } else if (!/^[0-9]+$/.test(values.employeeid)) {
    error.employeeid = toast.error('Employee ID must only contain numbers');
  }
  return error;
}



/** validate DOB */
function DOBVerify(error = {}, values) {
  if (!values.dob) {
    error.dob = toast.error('Date of Birth is required');
  } else if (!/^\d{2}-\d{2}-\d{4}$/.test(values.dob)) {
    error.dob = toast.error('Date of Birth must be in DD-MM-YYYY format');
  }
  return error;
}

/** validate PhoneNumber */
function PhoneNumberVerify(error = {}, values) {
  if (!values.phonenumber) {
    error.phonenumber = toast.error('Phone number is required');
  } else if (!/^[0-9]{10}$/.test(values.phonenumber.trim())) {
    error.phonenumber = toast.error('Phone number must be 10 digits, like 6477030040');
  }
  return error;
}

/** validate specialistID */
function specialistIdVerify(error = {}, values) {
  //FN: need to match with fullname to verify initials

  if (!values.specialistId) {
    error.specialistId = toast.error('Initials are required.'); 
  } else if (!/^[A-Z]{2}$/.test(values.specialistId)) {
     error.specialistId = toast.error('Initials should contain 2 uppercase letters only.');
  }
  return error;
}

